/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Save_Time_Feature_1Inputs */

const en_homepage_save_time_feature_1 = /** @type {(inputs: Homepage_Save_Time_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening allows you to select which sections of a paper to listen to`)
};

const es_homepage_save_time_feature_1 = /** @type {(inputs: Homepage_Save_Time_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening te permite seleccionar qué secciones de un artículo escuchar`)
};

/**
* | output |
* | --- |
* | "Listening allows you to select which sections of a paper to listen to" |
*
* @param {Homepage_Save_Time_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_save_time_feature_1 = /** @type {((inputs?: Homepage_Save_Time_Feature_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Save_Time_Feature_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_save_time_feature_1(inputs)
	return en_homepage_save_time_feature_1(inputs)
});